/**
 * Decodes a Base64-encoded string into an object.
 *
 * The function expects the Base64 string to represent a URL-encoded query string,
 * decodes it, and then converts it into an object using `URLSearchParams`.
 *
 * @param base64String - The Base64-encoded string to decode.
 * @returns The decoded object if successful, or `null` if decoding fails.
 */
export function decodeBase64ToObject(base64String: string): any | null {
  try {
    const jsonString = atob(base64String);
    return Object.fromEntries(new URLSearchParams(jsonString));
  } catch (e) {
    return null;
  }
}
